import React from "react";
import { ExportAuditList } from "@/components/main/governance/ExportAuditList";
import {
  LogFeed,
  LogSlideOver,
} from "@/components/main/governance/LogSlideOver";
import { useExportAudit } from "@/components/main/governance/useExportAudit";

interface Props {
  open: boolean;
  onClose: () => void;
  orgId: string;
  title: string;
  admin?: boolean;
}

export const ExportAuditPanel: React.FC<Props> = ({
  open,
  onClose,
  orgId,
  title,
  admin,
}) => (
  <LogSlideOver open={open} onClose={onClose} title={title}>
    {(mounted) => <ExportFeed orgId={mounted ? orgId : null} admin={admin} />}
  </LogSlideOver>
);

const ExportFeed: React.FC<{ orgId: string | null; admin?: boolean }> = ({
  orgId,
  admin,
}) => {
  const feed = useExportAudit(orgId, undefined, admin);
  return (
    <LogFeed feed={feed} loadingLabel="Loading exports…">
      <ExportAuditList entries={feed.entries} />
    </LogFeed>
  );
};
